/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1Fincen314MatchEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_FINCEN314_MATCH_EVENT_ENTITY_NAME = 'ixf.watchlist.v1.Fincen314MatchEvent';
export const ixfWatchlistV1Fincen314MatchEventEntity = new schema.Entity<IxfWatchlistV1Fincen314MatchEvent>(IXF_WATCHLIST_V1_FINCEN314_MATCH_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfWatchlistV1Fincen314MatchEvent) => `${entity.metadata?.eventId}` });

